<template>
  <aside class="app-sidebar">
    <div class="app-sidebar__user text-center">
      <img class="mb-3" :src="`data:image/png;base64,${user.account?.image}`" alt="User Image" width="100">
      <!-- <img class="mb-3" src="@/assets/user.png" alt="User Image" width="120"> -->
      <div>
        <p class="app-sidebar__user-name">{{ user.name }}</p>
        <p class="app-sidebar__user-designation">{{ user.account?.job_position || 'No Position' }}</p>
        <p class="app-sidebar__user-designation">
          <span>{{ user.account?.department.name }}</span>
        </p>
      </div>
    </div>
    <ul class="app-menu">
      <!-- Menu items -->
      <!-- <pre>{{user}}</pre> -->
      <!-- <li>
        <router-link class="app-menu__item" to="/dashboard">
          <i class="app-menu__icon bi bi-speedometer"></i>
          <span class="app-menu__label">Dashboard</span>
        </router-link>
      </li>
      <li>
        <router-link class="app-menu__item" to="/docs">
          <i class="app-menu__icon bi bi-code-square"></i>
          <span class="app-menu__label">Docs</span>
        </router-link>
      </li> -->
      <!-- <li>
        <router-link class="app-menu__item" :to="{ name: 'Dashboard' }">
          <i class="app-menu__icon bi bi-speedometer"></i>
          <span class="app-menu__label">หน้าหลัก</span>
        </router-link>
      </li> -->
      <li>
        <router-link class="app-menu__item" :to="{ name: 'Dashboard' }">
          <i class="app-menu__icon bi bi-list-task"></i>
          <span class="app-menu__label">บันทึกภาระงานที่ปฏิบัติ</span>
        </router-link>
      </li>
      <!-- <li>
        <router-link class="app-menu__item" :to="{ name: 'Booking' }">
          <i class="app-menu__icon bi bi-cursor"></i>
          <span class="app-menu__label">จองห้องประชุม</span>
        </router-link>
      </li> -->
      <div v-if="role == 'admin' || role == 'manager'">
        <!-- <li>
          <router-link class="app-menu__item" :to="{ name: 'Wait' }">
            <i class="app-menu__icon bi bi-hourglass text-success"></i>
            <span class="app-menu__label">รายการ (รออนุมัติ)</span>
          </router-link>
        </li> -->
        <!-- <li>
          <router-link class="app-menu__item" :to="{ name: 'Items' }">
            <i class="app-menu__icon bi bi-list-ol"></i>
            <span class="app-menu__label">รายการจองห้องประชุม</span>
          </router-link>
        </li> -->
      </div>
      <div v-if="role == 'admin'">
        <li class="treeview">
          <router-link class="app-menu__item" to="" data-toggle="treeview">
            <i class="app-menu__icon bi bi-gear"></i>
            <span class="app-menu__label">ตั้งค่า</span>
            <i class="treeview-indicator bi bi-chevron-right"></i>
          </router-link>
          <ul class="treeview-menu">
            <!-- <li>
              <router-link class="app-menu__item" :to="{ name: 'GroupDepartment' }">
                <i class="app-menu__icon bi bi-sliders2"></i>
                <span class="app-menu__label">จัดการหน่วยงาน</span>
              </router-link>
            </li>
            <li>
              <router-link class="app-menu__item" :to="{ name: 'MeetingRoom' }">
                <i class="app-menu__icon bi bi-sliders2"></i>
                <span class="app-menu__label">ห้องประชุม</span>
              </router-link>
            </li>
            <li>
              <router-link class="app-menu__item" :to="{ name: 'Equipment' }">
                <i class="app-menu__icon bi bi-sliders2"></i>
                <span class="app-menu__label">อุปกรณ์โสตทัศนูปกรณ์</span>
              </router-link>
            </li>
            <li>
              <router-link class="app-menu__item" :to="{ name: 'RoomLayout' }">
                <i class="app-menu__icon bi bi-sliders2"></i>
                <span class="app-menu__label">รูปแบบการจัดห้อง</span>
              </router-link>
            </li>
            <li>
              <router-link class="app-menu__item" :to="{ name: 'MeetingType' }">
                <i class="app-menu__icon bi bi-sliders2"></i>
                <span class="app-menu__label">ประเภทการประชุม</span>
              </router-link>
            </li> -->
          </ul>
        </li>
      </div>
    </ul>
  </aside>
</template>

<script setup>
import { useStore } from 'vuex';
import { computed } from 'vue';

const store = useStore();

// Map the user state using computed property
const user = computed(() => store.state.user || '');
const role = computed(() => store.state.role || '');
</script>

<style scoped>
/* Add your styles here */
.app-sidebar__user {
  display: block;
  margin-bottom: 0px;
}
</style>
